<style>
  Example

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  /* input[type=number] {
  -moz-appearance: textfield;
} */
</style>
<a id="mbfs-header-login-cta" id="auto_trigger_registration" class="mbfs-header-login-cta-a" href="javascript:void(0)"
  (click)="onClickLogin($event)" hidden></a>
<form [formGroup]="userForm" (ngSubmit)="verifyUserId($event)" *ngIf="openLoginModal && !userExist && !profileExist">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>
    <div  class="mbfs-modal-content">
      <div *ngIf="!isCanadaPortal" style="text-align: left;">
         <a (click)="clickvideo('registration');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
      </div>
      <div *ngIf="isCanadaPortal" style="text-align: left;">
        <a (click)="clickvideo('registrationCA');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
     </div>
      <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>

      <div class="mbfs-bank-profile-create-inner">
        <!-- User ID -->
        <div class="mbfs-text-input" [ngClass]="formValidationClasses">
          <div class="form-group row s-2">
            <div class="input-group">
              <label class="col-md-3 col-form-label" style="text-align:left;" for="userID">{{ 'LoginModal.UserLabel' |
                translate }}</label>
              <input type="text" id="userID" name="userID" class="col-md-6 form-control" formControlName="userID"
                required validateonblur value="" autocomplete="off" />
            </div>
          </div>
            <span class="spanRedTag"
              *ngIf="this.userForm.get('userID') && this.userForm.get('userID').errors && this.userForm.get('userID').dirty && this.userForm.get('userID').touched && this.userForm.get('userID').errors.required">{{
              'Errors.userIdRequired' | translate }}<br></span>
            <span class="spanRedTag"
              *ngIf="this.userForm.get('userID') && this.userForm.get('userID').errors && this.userForm.get('userID').dirty && this.userForm.get('userID').touched && this.userForm.get('userID').errors.minlength">{{
              'Errors.userIdminlength' | translate }}<br></span>
            <span class="spanRedTag"
              *ngIf="this.userForm.get('userID') && this.userForm.get('userID').errors && this.userForm.get('userID').dirty && this.userForm.get('userID').touched && this.userForm.get('userID').errors.maxlength">{{
              'Errors.userIdmaxlength' | translate }}<br></span>
  
          <!-- password -->
          <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" style="text-align:left;" class="col-md-3 col-form-label">{{
                  'LoginModal.SelectPassword1' | translate }}</label>
                <input type="password" name="password" id="password" #password1 class="col-sm-6 form-control"
                  formControlName="password" required validateonblur value="" onPaste="return false" autocomplete="off">

                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                  <span class="input-group-text"><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" style="text-align:left;" class="col-md-3 col-form-label">{{
                  'LoginModal.ReEnterPassword' | translate }}</label>
                <input type="password" name="repassword" id="repassword" #password2 class="col-sm-6 form-control"
                  formControlName="repassword" required validateonblur value="" onPaste="return false"
                  autocomplete="off">

                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password2, hide2)">
                  <span class="input-group-text"><i [ngClass]="hide2 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
          <div class="testtext">
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasMinimum">{{ 'LoginModal.Minimum' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasNumeric">{{ 'LoginModal.Numeric' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasLowerCase">{{ 'LoginModal.LowerCase' |
              translate }}</li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasUpperCase">{{ 'LoginModal.UpperCase' |
              translate }}</li>
            <li style="color:white;"
              *ngIf="this.userIDcheck && this.userForm.get('password') && this.userForm.get('password').errors && this.userForm.get('password').errors.pattern">
              {{ 'LoginModal.SpecialCharacter' | translate }}</li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasMaximum">{{ 'LoginModal.Maximum' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasSpecialCharacter">{{ 'LoginModal.SpecialChar' | translate }}</li>
            <li style="color:white;" *ngIf="!this.reentercheck">{{ 'LoginModal.ReEnterCheck' | translate }}</li>
           
          </div><br>
          <!-- <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
            <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
          </div> -->
          <!-- <div style="text-align: left;"> -->
            <!-- <li style="color:white;"
              *ngIf="this.userForm.get('userID') && this.userForm.get('userID').errors && this.userForm.get('userID').errors.required">
              {{ 'Errors.userIdminlength' | translate }}</li>
            <li style="color:white;"
              *ngIf="this.userForm.get('userID') && this.userForm.get('userID').errors && this.userForm.get('userID').errors.minlength">
              {{ 'Errors.userIdminlength' | translate }}</li>
            <li style="color:white;"
              *ngIf="this.userForm.get('emailAddress') && this.userForm.get('emailAddress').errors && this.userForm.get('emailAddress').errors.required">
              {{ 'Errors.emailrequired' | translate }} </li>
            <li style="color:white;"
              *ngIf="this.userForm.get('emailAddress') && this.userForm.get('emailAddress').errors && this.userForm.get('emailAddress').errors.pattern">
              {{ 'Errors.emailpattern' | translate }} </li> -->


            <!-- <li style="color:white;"  *ngIf="this.userForm.get('password') && this.userForm.get('password').errors && this.userForm.get('password').errors.required">{{ 'LoginModal.PasswordRequired' | translate }} </li> -->
            <!-- <li style="color:white;"  *ngIf="!this.userIDcheck">{{ 'LoginModal.UserIdCheck' | translate }}</li> -->
            <!-- <li style="color:white;"  *ngIf="!this.reentercheck">{{ 'LoginModal.ReEnterCheck' | translate }}</li> -->
            <!-- <li style="color:white;"  *ngIf="!this.reenteremailcheck">{{ 'LoginModal.ReEnterEmailCheck' | translate }}</li> -->
          <!-- </div><br> -->
          <div class="row">
            <div class="col">
              <input type="checkbox" checked="this.emailOffers" (change)="this.emailOffers = !this.emailOffers" />
              <span class="mbfs-passwordreset-p"> {{ 'LoginModal.CheckBox' | translate }}</span>
            </div>
          </div>
          <!--Error Display to Modal View-->
          <div class="captcha" *ngIf="this.captchaToggle">
            <div id="capcha_element" class="g-recaptcha" data-theme="light"
              style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;"
              data-callback="getResponceCapcha" data-expired-callback="recaptchaResponseExpired"
              data-error-callback="recaptchaError">
            </div>
          </div>
          <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
            <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
          </div>


          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <div class="mbfs-loading-spinner-overlay"></div>
            <div class="mbfs-loading-spinner"> </div>
          </div>
        </div>
      </div>
        <div class="registrationlinks">
          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event)">{{ 'LoginModal.Cancel' | translate
            }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
          <br>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <form [formGroup]="passwordForm" (ngSubmit)="prepareToRegisterUser($event)"
  *ngIf="openLoginModal && userExist && !profileExist">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>

    <div class="mbfs-modal-content">
      <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
      <div class="mbfs-bank-profile-create-inner">

        <div class="mbfs-text-input" [ngClass]="formValidationClasses">

          <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" style="text-align:left;" class="col-md-3 col-form-label">{{
                  'LoginModal.SelectPassword1' | translate }}</label>
                <input type="password" name="password" id="password" #password1 class="col-sm-6 form-control"
                  formControlName="password" required validateonblur value="" onPaste="return false" autocomplete="off">

                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                  <span class="input-group-text"><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" style="text-align:left;" class="col-md-3 col-form-label">{{
                  'LoginModal.ReEnterPassword' | translate }}</label>
                <input type="password" name="repassword" id="repassword" #password2 class="col-sm-6 form-control"
                  formControlName="repassword" required validateonblur value="" onPaste="return false"
                  autocomplete="off">

                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password2, hide2)">
                  <span class="input-group-text"><i [ngClass]="hide2 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="testtext">
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasMinimum">{{ 'LoginModal.Minimum' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasNumeric">{{ 'LoginModal.Numeric' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasLowerCase">{{ 'LoginModal.LowerCase' |
              translate }}</li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasUpperCase">{{ 'LoginModal.UpperCase' |
              translate }}</li>
            <li style="color:white;"
              *ngIf="this.userIDcheck && this.passwordForm.get('password') && this.userForm.get('password').errors && this.passwordForm.get('password').errors.pattern">
              {{ 'LoginModal.SpecialCharacter' | translate }}</li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasMaximum">{{ 'LoginModal.Maximum' | translate }}
            </li>
            <li style="color:white;" *ngIf="this.userIDcheck && !this.hasSpecialCharacter">{{ 'LoginModal.SpecialChar' | translate }}</li>
            <li style="color:white;" *ngIf="!this.reentercheck">{{ 'LoginModal.ReEnterCheck' | translate }}</li>
           
          </div><br>


          <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
            <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
          </div>
          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <div class="mbfs-loading-spinner-overlay"></div>
            <div class="mbfs-loading-spinner"> </div>
          </div>
        </div>
        <div class="registrationlinks">
          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event)">{{ 'LoginModal.Cancel' | translate
            }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
          <br>
        </div>
      </div>
    </div>
  </div>
</form> -->



<!-- Profile modal for adding accounts-->
<form [formGroup]="profileForm" (ngSubmit)="prepareAccountSetup($event)" *ngIf="openLoginModal && profileExist">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>

    <div class="mbfs-modal-content" *ngIf="profileExist">
      <!-- <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3> -->
      <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
      <!-- Email -->
      <div class="mbfs-text-input" [ngClass]="formValidationClasses">
        <div class="form-group row s-2">
          <div class="input-group">
            <label for="email" style="text-align:left;" class="col-md-3 col-form-label">{{ 'LoginModal.NewEmail' |
              translate }}</label>
            <input type="text" name="emailAddress" id="emailAddress" #email1 class="col-sm-6 form-control"
              formControlName="emailAddress" required validateonblur value="" autocomplete="off">
          </div>
        </div>
      </div>
        <span class="spanRedTag"
          *ngIf="this.profileForm.get('emailAddress') && this.profileForm.get('emailAddress').errors && this.profileForm.get('emailAddress').touched && this.profileForm.get('emailAddress').errors.required">
          {{ 'Errors.emailrequired' | translate }}<br></span>
        <span class="spanRedTag"
          *ngIf="this.profileForm.get('emailAddress') && this.profileForm.get('emailAddress').errors && this.profileForm.get('emailAddress').touched && this.profileForm.get('emailAddress').errors.pattern">
          {{ 'Errors.emailpattern' | translate }} <br></span>
      <div class="mbfs-bank-profile-create-inner">
<!-- customer number -->
        <div class="mbfs-text-input" [ngClass]="formValidationClasses">
          <div class="form-group row s-2">
            <div class="input-group">
              <label for="customerNumber" style="text-align:left;" class="col-md-3 col-form-label">{{
                'LoginModal.CustomerNumber' | translate }}</label>
              <input type="text" name="customerNumber" id="customerNumber" class="col-sm-6 form-control"
                oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);"
                formControlName="customerNumber" required validateonblur value="" autocomplete="off">
            </div>
          </div>
        </div>
        <p class="mbfs-passwordreset-p">{{ 'LoginModal.CustomerTip' | translate }}</p>
        <div class="mbfs-text-input" [ngClass]="formValidationClasses">
          <div class="form-group row s-2">
            <div class="input-group">
              <label for="contractNumber" style="text-align:left;" class="col-md-3 col-form-label">{{
                'LoginModal.SSNTAX' | translate }}</label>
              <input *ngIf="!isCanadaPortal" (keypress)="numberOnly($event)" type="text" name="contractNumber"
                id="contractNumber"
                oninput="javascript: if (this.value.length > 4) this.value = this.value.slice(0, 4);"
                class="col-sm-6 form-control" formControlName="contractNumber" required validateonblur value=""
                autocomplete="off">
              <input *ngIf="isCanadaPortal" type="text" name="contractNumber" id="contractNumber"
                oninput="javascript: if (this.value.length > 13) this.value = this.value.slice(0, 13);"
                class="col-sm-6 form-control" formControlName="contractNumber" required validateonblur value=""
                autocomplete="off">
            </div>
          </div>
        </div>
        <p class="mbfs-passwordreset-p">{{ 'LoginModal.ContractTip' | translate }}</p>

        <!--Error Display to Modal View-->
        <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
          <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
        </div>
        <!-- <button mat-button (click)="openDialog()">Launch dialog</button> -->
        <!--Spinner on Login Load-->
        <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
          <div class="mbfs-loading-spinner-overlay"></div>
          <div class="mbfs-loading-spinner"> </div>
        </div>
        <div class="registrationlinks">
          <button type="submit" (click)="goBack()" class="mbfs-button">{{
            'LoginModal.back' | translate
            }}</button>
          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event);">{{ 'LoginModal.Cancel' | translate
            }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
          <br>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <form [formGroup]="emailForm" (ngSubmit)="prepareEmailSetup($event)" *ngIf="openLoginModal && userblock">
      <div class="mbfs-bank-profile-create-modal1 mbfs-modal" focustrapper aria-live="polite"
      [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
        <div class="mbfs-modal-overlay"></div>  
    
          <div class="mbfs-modal-content">  
              <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
              <div class="mbfs-bank-profile-create-inner">   
                <div class="mbfs-text-input" [ngClass]="formValidationClasses">

                  <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                    <div class="form-group row s-2">
                      <div class="input-group">
                        <label for="email" style="text-align:left;" class="col-md-3 col-form-label">{{ 'LoginModal.NewEmail' | translate }}</label>
                        <input type="text" name="emailAddress" id="emailAddress" #email1 class="col-sm-6 form-control"
                        formControlName="emailAddress" required validateonblur
                        value="" autocomplete="off">
                      
                      </div>
                    </div>
                  </div>
                  <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                    <div class="form-group row s-2">
                      <div class="input-group">
                        <label for="email" style="text-align:left;" class="col-md-3 col-form-label">{{ 'LoginModal.ReEnterEmail' | translate }}</label>
                        <input type="text" name="reEnterEmailAddress" id="reEnterEmailAddress" #email2 class="col-sm-6 form-control"
                        formControlName="reEnterEmailAddress" required validateonblur
                        value="" autocomplete="off">
                      
                      </div>
                    </div>
                  </div>
                  <div class="testtext">  
                    <li style="color:white;"  *ngIf="!this.reenteremailcheck">{{ 'LoginModal.ReEnterEmailCheck' | translate }}</li>
                    <li style="color:white;"  *ngIf="!this.reentercheck">{{ 'LoginModal.ReEnterCheck' | translate }}</li>
                  </div><br>
                  

                <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
                  <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
                </div>
                  <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
                </div>
                  </div>
                  <div class ="registrationlinks">
                    <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>                
                    <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event)">{{ 'LoginModal.Cancel' | translate }}</button>
                    <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
                      <br>
                  </div>
                </div>
              </div>
             </div>      
    </form>  -->

<!--If Email setup is successful show Email has been sent block -->

<form *ngIf="openLoginModal && optionExist">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>

    <div class="mbfs-modal-content">
      <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
      <div class="mbfs-bank-profile-create-inner">
        <div *ngIf="(!numAttempts && !userActive)">
          <div class="registrationlinks">
            <p class="mbfs-passwordreset-title">{{ 'LoginModal.EmailSent' | translate }} {{this.maskedEmail}} {{
              'LoginModal.EmailVerbiage1' | translate }}</p>
            <p class="mbfs-passwordreset-p">{{ 'LoginModal.RegisterVerbiage1' | translate }}</p>
          </div>

          <button type="submit" class="mbfs-button" [disabled]="!this.loginLoaded" (click)="prepareEmailSetup()">{{
            'LoginModal.ResendLink' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)" id="close">X</button>
        </div>

        <div *ngIf="numAttempts">
          <div class="registrationlinks">
            <p class="mbfs-passwordreset-title">{{ 'LoginModal.EmailSent' | translate }} {{this.maskedEmail}} {{
              'LoginModal.EmailVerbiage1' | translate }}</p>
            <p class="mbfs-passwordreset-p">{{ 'LoginModal.Attempts' | translate }}</p>
          </div>
          <!--Spinner on Login Load-->
          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <div class="mbfs-loading-spinner-overlay"></div>
            <div class="mbfs-loading-spinner"> </div>
          </div>
          <button type="submit" class="mbfs-button" (click)="openRegistration($event)">{{ 'LoginModal.ReRegister' |
            translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
        </div>

        <div *ngIf="userActive">
          <div class="registrationlinks">
            <p class="mbfs-passwordreset-title">{{ 'LoginModal.Success' | translate }}</p>
          </div>
          <!--Spinner on Login Load-->
          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <div class="mbfs-loading-spinner-overlay"></div>
            <div class="mbfs-loading-spinner"> </div>
          </div>
          <button type="submit" class="mbfs-button" (click)="openLogin($event)">{{ 'LoginModal.LogIn' | translate
            }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
        </div>
        <br>
      </div>
    </div>
  </div>
</form>